import { RECIPIENT_FILTER_ATTRIBUTES } from "../consts/recipientFilter";

export const formatFilterToRender = (parsedFilter) => {
    const filters = [];
        let index = 0;
        while(index <= parsedFilter.length) {
            const attribute = parsedFilter[index]?.attribute;
            const values = parsedFilter[index]?.values;
            let operator;
            if(index < parsedFilter.length){
                operator = parsedFilter[index + 1]?.value;
            }
            filters.push({
                attribute,
                values,
                operator,
            });
            index += 2;
        }
    return filters;
}

export const mapAttributeToLabel = (attribute) => {
    const attr = RECIPIENT_FILTER_ATTRIBUTES.find(attr => attr.value === attribute);
    return attr?.label || attribute;
}